<h1>Vos moyens de paiement</h1>

<div class="noinvoiceblock" *ngIf="suppliersList?.length === 0">
  <div class="icon" uiSvg source="assets/images/InfoQuitSaveHero"></div>
  <p class="bold">Vous n'avez pas encore de moyen de paiement
  <p>
  <p>Vous pourrez le configurer dès l'arrivée de votre première facture.</p>
</div>
<div class="pnl-supplier">
  <div class="supplier-info" data-testid="payment-means-supplier" *ngFor="let supplier of suppliersList">
    <div class="payment-means-head">
      <div class="title">
        <p class="info">Vous avez contractualisé avec :</p>
        <p class="suppliers">{{contractSupplier(supplier.FournisseurId)}}</p>
      </div>
      <div class="logo">
        <span class="supplier" uiSvg source="assets/images/{{logoSupplier(supplier.FournisseurId)}}"></span>
      </div>
    </div>

    <hr>

    <p class="payment-text">Vos moyens de paiements associés</p>

    <h2 id="subtitle-sepa">Mandat SEPA</h2>
    <p id="sepa-type-label" *ngIf="loadSepaMandate(supplier.FournisseurId)" data-testid="payment-means-sepa-type">
      <fa-icon [icon]="faCheckCircle"></fa-icon>
      Prélèvement automatique à la date d'échéance de chaque facture.
    </p>
    <div class="pnl-sepa"
      [ngClass]="{'after-sepa-sign': sepaSignStatus === SignatureState.SIGNED && sepaSignSupplierId === supplier.FournisseurId}">
      <div class="active" *ngIf="loadSepaMandate(supplier.FournisseurId); let sepaMandate">
        <div class="corporate-name">{{sepaMandate.CompanyName}}</div>
        <div class="address">{{sepaMandate.Address}}, {{sepaMandate.ZipCode}} {{sepaMandate.City}}</div>
        <div class="rum"><span class="bank-label">RUM</span>{{sepaMandate.Rum}}</div>
        <div class="iban"><span class="bank-label">IBAN</span>{{sepaMandate.Iban}}</div>
        <div class="bic"><span class="bank-label">BIC</span>{{sepaMandate.Bic}}</div>
      </div>
      <div class="sign" *ngIf="!loadSepaMandate(supplier.FournisseurId)">
        <div class="signed-sepa-check" data-testid="payment-means-signed-sepa-message"
          *ngIf="hasSepaMandateInProgress(supplier.FournisseurId)">
          <span>
            <fa-icon [icon]="faCheckCircle"></fa-icon>
            Mandat SEPA signé
          </span>
          <p>Votre mandat SEPA est en cours de vérification.<br>
            Un message vous sera envoyé lorsque celui-ci sera vérifié.
          </p>
        </div>
        <div class="no-sepa" *ngIf="!hasSepaMandateInProgress(supplier.FournisseurId)">
          <p>Passez au prélèvement bancaire</p>
          <div>
            <img src="assets/images/add-sepa-v2.png" alt="Ajout sepa">
          </div>
          <button [apply-write-rights]="rights.Payment" data-testid="payment-means-add-sepa-mandate"
            class="ui-btn primary-btn" [routerLink]="['/sepa-mandate-sign', supplier.FournisseurId]">
            Signer un mandat SEPA
          </button>
        </div>
      </div>
    </div>

    <div class="pnl-credit-cards">
      <fs-credit-cards pageName="payment-means" [supplier]="supplier.FournisseurId"
        [cardsList]="getSupplierCardsList(supplier.FournisseurId)"
        [defaultCardId]="getDefaultCardId(supplier.FournisseurId)"
        [selectedCardId]="getDefaultCardId(supplier.FournisseurId)" (clickCard)="onClickCard($event)"
        (clickRemoveCard)="onClickRemoveCard($event)">
      </fs-credit-cards>
    </div>

    <hr>

    <div class="pnl-rib">
      Virement bancaire :
      <a class="download" [href]="loadUrlRib(supplier.FournisseurId)" target="_blank">
        <img src="assets/images/download-file-purple.png" alt="download-rib">
        Télécharger le RIB
      </a>
    </div>
  </div>
</div>

<ngx-smart-modal #removeCardModal identifier="removeCardModal" customClass="nsm-centered">
  <div class="modal-header">
    <h2>Supprimer cette carte bleue ?</h2>
  </div>
  <div class="modal-content">
    <p>En la supprimant, vous devez ressaisir les données d'une nouvelle carte.</p>
  </div>
  <div class="modal-footer">
    <button class="ui-btn secondary-btn" (click)="removeCardModal.close()">Non, je la garde</button>
    <button class="ui-btn primary-btn" (click)="onRemoveCardConfirmed()"
      data-testid="payment-means-delete-modal-confirm">Oui, je la supprime</button>
  </div>
</ngx-smart-modal>